import type { FC } from "react";
import { useMemo } from "react";
import { useDialog } from "../../../../utils/hooks/use-dialog";
import type { CopyDialogProps } from "./copy-dialog";
import { CopyDialog } from "./copy-dialog";
import { CopyWarningDialogWithRename } from "./copy-warning-dialog-with-rename";

export function useCopyDialogs({ clonable }: { clonable: boolean | "warn_first" }): {
  handleCopy: () => void;
  dialogControl: ReturnType<typeof useDialog>;
  CopyDialogComponent?: FC<CopyDialogProps>;
} {
  const dialogControl = useDialog();
  const dialogComponent = useMemo(() => {
    if (clonable === "warn_first") return CopyWarningDialogWithRename;
    else return CopyDialog;
  }, [clonable]);

  return {
    handleCopy: dialogControl.handleOpen,
    dialogControl: dialogControl,
    CopyDialogComponent: dialogComponent,
  };
}
